import * as z from 'zod';

import { KnockoutType, OverviewType } from '../constants';

export const OverviewTypeIdSchema = z.enum(OverviewType);

export const LeagueOverviewTeamSchema = z.object({
  no: z.number(),
  leagueName: z.string(),
  playedMatches: z.number(),
  wins: z.number(),
  draws: z.number(),
  losses: z.number(),
  points: z.number(),
});

export const GroupOverviewTeamRowSchema = z.object({
  no: z.number(),
  name: z.string(),
  jersey: z.string().nullable(),
  playedMatches: z.number(),
  wins: z.number(),
  draws: z.number(),
  losses: z.number(),
  points: z.number(),
  isHome: z.boolean(),
  isAway: z.boolean(),
});

export const GroupTableSchema = z.object({
  groupName: z.string(),
  teams: z.array(GroupOverviewTeamRowSchema),
});

export const KnockoutOverviewTeamSchema = z.object({
  lastMatchGoalscorers: z.array(z.string()),
  rank: z.number().nullable(),
  missingPlayers: z.array(z.string()),
  flag: z.string().nullable(),
});

const KnockoutNationalSchema = z.object({
  type: z.literal(KnockoutType.NATIONAL_TEAM),
  home: KnockoutOverviewTeamSchema,
  away: KnockoutOverviewTeamSchema,
});

const KnockoutFinalPhaseSchema = z.object({
  type: z.literal(KnockoutType.FINAL_PHASE),
  home: KnockoutOverviewTeamSchema,
  away: KnockoutOverviewTeamSchema,
});

export const KnockoutOverviewSchema = z.discriminatedUnion('type', [
  KnockoutNationalSchema,
  KnockoutFinalPhaseSchema,
]);

const OverviewTableSchema = z.object({
  type: z.literal(OverviewType.TABLE),
  home: LeagueOverviewTeamSchema,
  away: LeagueOverviewTeamSchema,
  groupTable: z.null(),
  knockout: z.null(),
});

const OverviewGroupTableSchema = z.object({
  type: z.literal(OverviewType.GROUPS_TABLES),
  home: z.null(),
  away: z.null(),
  groupTable: GroupTableSchema,
  knockout: z.null(),
});

const OverviewKnockoutSchema = z.object({
  type: z.literal(OverviewType.KNOCKOUT),
  home: z.null(),
  away: z.null(),
  groupTable: z.null(),
  knockout: KnockoutOverviewSchema,
});

const OverviewSchema = z.discriminatedUnion('type', [
  OverviewTableSchema,
  OverviewGroupTableSchema,
  OverviewKnockoutSchema,
]);

export default OverviewSchema;
